import Select from 'react-select'
import { DateField } from '@astro/date-field'
import { ksSelectStyles } from './StudioBits'

/* Filter bar for the saved-kundli history — each control maps 1:1 onto a
   GET /kundlis query param; '' means "not filtering on this". */

const GENDER_OPTIONS = [
  { value: '', label: 'Any gender' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
]

const SOURCE_OPTIONS = [
  { value: '', label: 'Cast anywhere' },
  { value: 'seeker_dashboard', label: 'My dashboard' },
  { value: 'website', label: 'Website Astro Tools' },
  { value: 'astrologer_dashboard', label: 'Astrologer console' },
  { value: 'app', label: 'Mobile app' },
]

const SORT_OPTIONS = [
  { value: '', label: 'Recently opened' },
  { value: 'created', label: 'Newest saved' },
  { value: 'name', label: 'Name (A–Z)' },
  { value: 'birth_date', label: 'Birth date (youngest first)' },
]

export const NO_FILTERS = { gender: '', source: '', birth_date_from: '', birth_date_to: '', sort: '' }

const pick = (options, value) => options.find((o) => o.value === value) ?? options[0]

function SelectFilter({ id, label, options, value, onChange }) {
  return (
    <div>
      <label className="flbl" htmlFor={id}>{label}</label>
      <Select
        inputId={id}
        options={options}
        value={pick(options, value)}
        onChange={(o) => onChange(o?.value ?? '')}
        styles={ksSelectStyles}
        isSearchable={false}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  )
}

export default function SavedKundliFilters({ search, onSearch, filters, onChange, onClear, canClear }) {
  const set = (key) => (value) => onChange({ ...filters, [key]: value })

  return (
    <div className="ks-saved-filters">
      <div>
        <label className="flbl" htmlFor="ks-saved-q">Search</label>
        <input
          id="ks-saved-q"
          type="search"
          className="field"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Name, label or place…"
        />
      </div>
      <SelectFilter id="ks-saved-gender" label="Gender" options={GENDER_OPTIONS} value={filters.gender} onChange={set('gender')} />
      <SelectFilter id="ks-saved-source" label="Cast from" options={SOURCE_OPTIONS} value={filters.source} onChange={set('source')} />
      <div>
        <label className="flbl" htmlFor="ks-saved-from">Born on or after</label>
        <DateField
          id="ks-saved-from"
          value={filters.birth_date_from}
          max={filters.birth_date_to || undefined}
          onChange={(e) => set('birth_date_from')(e.target.value)}
        />
      </div>
      <div>
        <label className="flbl" htmlFor="ks-saved-to">Born on or before</label>
        <DateField
          id="ks-saved-to"
          value={filters.birth_date_to}
          min={filters.birth_date_from || undefined}
          onChange={(e) => set('birth_date_to')(e.target.value)}
        />
      </div>
      <SelectFilter id="ks-saved-sort" label="Sort by" options={SORT_OPTIONS} value={filters.sort} onChange={set('sort')} />
      {canClear && (
        <button type="button" className="ks-ghost-btn ks-saved-clear" onClick={onClear}>
          ✕ Clear filters
        </button>
      )}
    </div>
  )
}
